var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('about-introduction'), _c('about-plant'), _c('about-company')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }